import { useEffect } from 'react';
import { BrandLogo, ProductMark, PRODUCT_NAME } from './Brand.jsx';
import ExternalLink from './ExternalLink.jsx';
import { HeaderAccent } from './TopBar.jsx';
import BrandFooter from './BrandFooter.jsx';
import { BRAND } from '../lib/brand.js';
import { ensureNoReferrer } from '../lib/watch-fragment.js';
import { WATCH_CONTACT_LINE } from '../../../shared/watch-footer.mjs';

// Full screen without the sidebar, like Onboarding (spec 9.4, A26). The
// product name is plain text: these pages never offer a login or link into
// the app. The contact line is the email footer's (shared/watch-footer.mjs).
export const CONTACT_LINE = WATCH_CONTACT_LINE;

export default function PublicWatchShell({ children }) {
  useEffect(() => { ensureNoReferrer(document); }, []);
  return (
    <div className="flex min-h-screen flex-col bg-ipc-surface">
      <header className="on-dark bg-ipc-primary text-white shadow-md">
        <div className="mx-auto flex h-14 max-w-xl items-center gap-3 px-4">
          <ExternalLink href={BRAND.siteUrl} className="shrink-0 rounded">
            <BrandLogo tone="light" className="h-6 w-auto sm:h-7" />
          </ExternalLink>
          <span aria-hidden="true" className="h-6 w-px shrink-0 bg-white/30" />
          <span className="flex min-w-0 items-center gap-2 text-sm font-semibold tracking-tight sm:text-base">
            <ProductMark tone="light" size={28} />
            <span className="truncate">{PRODUCT_NAME}</span>
          </span>
        </div>
        <HeaderAccent />
      </header>
      <main className="flex-1">
        <div className="mx-auto max-w-xl space-y-6 px-4 py-8">
          {children}
          <p className="text-xs text-slate-600">{CONTACT_LINE}</p>
        </div>
      </main>
      {/* Watch capability pages link nowhere into the app (spec 9.4), so no Security link here. */}
      <BrandFooter securityLink={false} />
    </div>
  );
}
